import { render, staticRenderFns } from "./permissionCom.vue?vue&type=template&id=25f0dcd6&scoped=true&"
import script from "./permissionCom.vue?vue&type=script&lang=js&"
export * from "./permissionCom.vue?vue&type=script&lang=js&"
import style0 from "./permissionCom.vue?vue&type=style&index=0&id=25f0dcd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f0dcd6",
  null
  
)

export default component.exports